import type { ZapiAction, ZapiParamsMap } from '@weft/zapi-types';
import { END_TIME_QUERY_PARAM, PAGINATION_QUERY_PARAMETERS, SEARCH_QUERY_PARAMETER, START_TIME_QUERY_PARAM } from '../../../api-definition-params';
import { GET_PAYMENT_OVERVIEWS_PATH } from './get-payment-overviews-path';
import { GetPaymentsOverviewsResponseSchema } from './get-payments-overviews-response-schema';

export const GET_PAYMENTS_OVERVIEWS_ACTION = {
  method: 'get',
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [SEARCH_QUERY_PARAMETER.name]: SEARCH_QUERY_PARAMETER,
    [START_TIME_QUERY_PARAM.name]: START_TIME_QUERY_PARAM,
    [END_TIME_QUERY_PARAM.name]: END_TIME_QUERY_PARAM,
  } as const satisfies ZapiParamsMap,
  codeGenerationSettings: {
    actionText: 'get-payment-overviews',
  },
  response: {
    name: 'GetPaymentOverviewsResponse',
    schema: GetPaymentsOverviewsResponseSchema,
  },
  path: GET_PAYMENT_OVERVIEWS_PATH,
} satisfies ZapiAction;

export type GetPaymentsOverviewsAction = typeof GET_PAYMENTS_OVERVIEWS_ACTION;